export const trackingEventNames = {
    // Backend APIs
    UPLOAD_NEW_PATIENT: "Upload New Patient",
    PARSING_NEW_PATIENT: "Parsing New Patient",
    CREATE_PATIENT: "Create Patient",
    UPDATE_PATIENT_DATA: "Update Patient Data",
    CREATE_PLAN: "Create Plan",
    GET_PLAN: "Get Plan",
    UPDATE_PLAN: "Update Plan",
    DOWNLOAD_PLAN: "Download Plan",
    REVIEW_PLAN: "Review Plan",
    RESUME_PLAN: "Resume Plan",
    CREATE_VISIT: "Create Visit",
    UPDATE_VISIT: "Update Visit",
    SHARE_PATIENT: "Share Patient",
    UPDATE_CLINICIAN: "Update Clinician",
    CREATE_NOTE: "Create Note",
    GET_NOTES: "Get Notes",
    ADD_PLAN_FLAG: "Add Plan Flag",
    GET_INST_USERS: "Get Institution Users",
    PLAN_LOCK: "Lock Plan",
    PLAN_UNLOCK: "Unlock Plan",
    PUSH_NOTIFICATION: "Push Notification",

    // TPlan
    FILE_UPLOAD: "File Upload",
    FILE_DELETE: "File Deletion",
    LOAD_MRI: "Load MRI",
    DELETE_MRI: "Delete MRI",
    CREATE_MARGIN: "Create Margin",
    CREATE_SEGMENTATION: "Create AI Segmentation",
    COMPLETE_FUSION: "Complete Koelis Fusion",
    CEM: "CEM Generation",
    UPDATE_BIOPSY_CORE: "Update Biopsy Core",
    LOAD_ROI: "Load ROIs",
    LOAD_PROSTATE: "Load Prostate",
    GET_BOUNDING_CONE: "Get Bounding Cone",
    GET_MESH_PROPERTIES: "Get Mesh Properties",
    ESTIMATE_MESH_VOL: "Estimate Mesh Volume",
    CREATE_MESH_FROM_FACE_VERTEX: "Create Mesh from Face Vertex",
    SUMMARY_PAGE_LOAD: "Summary Page Load",

    // User Account
    RESET_PW: "Reset Password",
    SET_PW: "Set Password",
    REPORT_BUG: "Report Bug",
    VERIFY_ACCT_LINKING: "Verify Account Linking",
    LOGIN: "Login",

    // Surgery Mode
    SURGERY_MODE_SESSION: "Surgery Mode Session",
};
